<template>
  <section>
    <div class="d-flex align-items-center mb-3 flex-wrap">
      <button
        id="allChalenge"
        @click="handleCheckAllChallenges"
        class="accept-all-challenge-button rounded-pill p-2"
      >
        Check all challenges as completed
      </button>
      <custom-check-filter
        :options="categoryOptions"
        :closeOnSelect="false"
        :customClass="'category-check-filter ml-0 ml-sm-auto mt-2 mt-sm-0 mb-3 mb-sm-0'"
        @onChangeChecked="selectedFilterValue"
      />
    </div>
    <div class="mb-2">
      <small class="m-0 text-muted">
        <span class="material-icons align-middle">swipe_down</span>
        You can sort the list of challenge goals
      </small>
    </div>
    <section>
      <challenges-list
        :current-child="currentChild"
        :filterSelected="categoriesSelected"
        :checkAll="checkAllCriteria"
        @onDeleteChallenge="handleDeleteChallenge"
        @onEditChallenge="handleEditChallenge"
        @onSave="handleSaveResponseOnChallenges"
        @onSort="handleSortChallenges"
      />
    </section>
    <challenge-parent-goal-modal ref="modal" :child="currentChild" :isNew="false" />
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import { defaultTodayString } from '@/utils/Dates.js';
import mixinNotificationToast from '@/mixins/notificationToast.mixin.js';

import customCheckFilter from '@/components/general/customCheckFilter/customCheckFilter.vue';
import ChallengesList from './ChallengesList.vue';
import ChallengeParentGoalModal from './modals/ChallengeParentGoalModal.vue';
import { Promise } from 'q';

export default {
  components: { customCheckFilter, ChallengesList, ChallengeParentGoalModal },
  mixins: [mixinNotificationToast],
  props: {
    currentChild: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      categoriesSelected: [],
      checkAllCriteria: false,
    };
  },
  computed: {
    ...mapGetters('challenge', ['getCriterionCategories']),
    categoryOptions() {
      const categoryOptions = this.getCriterionCategories.map(({ id, name, color }) => ({
        value: id,
        text: name,
        color,
      }));
      return [{ value: 0, text: 'No Category' }, ...categoryOptions];
    },
  },
  methods: {
    ...mapActions('challenge', [
      'DeleteCriterion',
      'setParentCheckValues',
      'updateChallengeOrderByChild',
    ]),
    handleCheckAllChallenges() {
      this.checkAllCriteria = !this.checkAllCriteria;
    },
    selectedFilterValue(categoriesSelected = []) {
      this.categoriesSelected = categoriesSelected.map((categorie) => categorie.value);
    },
    async openConfirmModal() {
      return await await this.$bvModal.msgBoxConfirm(
        'Do you want to delete permanently this goal?',
        {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-1',
          hideHeaderClose: false,
          centered: true,
        },
      );
    },
    async handleDeleteChallenge({ challenge, timeDay }) {
      try {
        const date = this.$route.query.date ? this.$route.query.date : defaultTodayString();
        const { challenge_criterion } = challenge;
        const response = await this.openConfirmModal();
        if (response) {
          await this.DeleteCriterion({
            criterionId: challenge_criterion,
            childId: this.currentChild,
            timeDay,
            date,
          });
        }
      } catch (error) {
        this.notificationToast({ message: error, variant: 'danger', title: 'Delete a Goal' });
      }
    },
    async handleEditChallenge({ challenge, timeDay }) {
      try {
        this.$refs.modal.openModal({ challenge, timeDay });
      } catch (error) {
        this.notificationToast({ message: error, variant: 'danger', title: 'Edit a Goal' });
      }
    },
    async handleSortChallenges({ challengesByTimeDay }) {
      try {
        const challengesOrderByday = Object.keys(challengesByTimeDay).map((timeDay) => ({
          time_day: timeDay,
          ordered_ids: challengesByTimeDay[timeDay].length
            ? challengesByTimeDay[timeDay].map((challenge) => challenge.challenge_criterion)
            : {},
        }));
        await this.updateChallengeOrderByChild({
          childId: this.currentChild,
          challengesOrderByday,
        });
      } catch (error) {
        this.notificationToast({ message: error, variant: 'danger', title: 'Sort' });
      }
    },
    async handleSaveResponseOnChallenges({ data }) {
      const time_days = Object.keys(data);
      const date = this.$route.query.date ? this.$route.query.date : defaultTodayString();
      const requestData = time_days.map((time_day) => ({
        time_day,
        date,
        childId: this.currentChild,
        items: Object.keys(data[time_day]).map((criterionId) => ({
          id: criterionId,
          value: data[time_day][criterionId]['value'],
        })),
      }));
      try {
        const promisesRequest = requestData.map((request) => this.setParentCheckValues(request));
        await Promise.all(promisesRequest);
      } catch (error) {
        this.notificationToast({ message: error, variant: 'danger', title: 'Save' });
      }
    },
  },
};
</script>
<style lang="scss">
.accept-all-challenge-button {
  background-color: #efefef;
  color: black !important;
  text-align: center;
  border: none;
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: #d3d1d1;
    text-decoration: none;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
}
</style>
